import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { CATEGORIES } from "@/lib/format";
import { useApi, errMsg } from "@/lib/api";

const num = (v) => (v === "" || v == null ? null : Number(v));

export function EstimatorSettings({ s, onSaved, onCancel }) {
  const api = useApi();
  const [f, setF] = useState({ ...s, rates: { ...s.rates } });
  const [busy, setBusy] = useState(false);
  const setRate = (k) => (e) => setF((x) => ({ ...x, rates: { ...x.rates, [k]: e.target.value } }));
  const set = (k) => (e) => setF((x) => ({ ...x, [k]: e.target.value }));
  const save = async () => {
    setBusy(true);
    try {
      const rates = Object.fromEntries(CATEGORIES.map((c) => [c.value, num(f.rates[c.value])]));
      const { data } = await api.put("/estimator/settings", { rates, min_hours_per_leg: Number(f.min_hours_per_leg), reposition_hours: Number(f.reposition_hours), range_pct: Number(f.range_pct) });
      toast.success("Estimator settings saved");
      onSaved(data);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const cls = "bg-[#0d0f14] border-white/10 h-9";
  return (
    <div className="space-y-4" data-testid="estimator-settings">
      <p className="eyebrow">Hourly rates (USD per flight hour, taxes and fees included)</p>
      <div className="grid grid-cols-2 gap-3">
        {CATEGORIES.map((c) => (
          <label key={c.value} className="text-[11px] text-zinc-400">{c.label}
            <Input className={cls} type="number" min="1" step="0.01" value={f.rates[c.value] ?? ""} onChange={setRate(c.value)} placeholder="No rate" data-testid={`estimator-rate-${c.value}`} />
          </label>
        ))}
      </div>
      <div className="grid grid-cols-3 gap-3">
        <label className="text-[11px] text-zinc-400">Minimum hours per leg<Input className={cls} type="number" min="0" step="0.1" value={f.min_hours_per_leg} onChange={set("min_hours_per_leg")} data-testid="estimator-min-hours" /></label>
        <label className="text-[11px] text-zinc-400">Repositioning hours<Input className={cls} type="number" min="0" step="0.1" value={f.reposition_hours} onChange={set("reposition_hours")} data-testid="estimator-reposition-hours" /></label>
        <label className="text-[11px] text-zinc-400">Range ± %<Input className={cls} type="number" min="0" max="50" step="1" value={f.range_pct} onChange={set("range_pct")} data-testid="estimator-range-pct" /></label>
      </div>
      <div className="flex justify-end gap-2">
        <button type="button" className="frame-btn !py-2.5" onClick={onCancel} data-testid="estimator-settings-cancel">Cancel</button>
        <button type="button" className="frame-btn gold !py-2.5" disabled={busy} onClick={save} data-testid="estimator-settings-save">{busy ? "Saving…" : "Save settings"}</button>
      </div>
    </div>
  );
}
